import { useContext, useEffect, useState } from "react";

import { getPlan } from "@/api/axios";
import { EnrollmentContext } from "@/state";

const medicarePartDStrategies = [
  "medicare_actuarially_equivalent_mapd",
  "medicare_basic_alternative_mapd",
  "medicare_defined_standard_mapd",
  "medicare_employer_group_waiver_plan_mapd",
  "medicare_enhanced_alternative_mapd",
  "medicare_actuarially_equivalent_pdp",
  "medicare_basic_alternative_pdp",
  "medicare_defined_standard_pdp",
  "medicare_employer_group_waiver_plan_pdp",
  "medicare_enhanced_alternative_pdp",
  "medicare_prescription_payment_plan",
];

export const useHasMedicarePlans = () => {
  const [state, _] = useContext(EnrollmentContext);
  const plans = state.experienceData.plan_csids;
  const [hasMedicarePlans, setHasMedicarePlans] = useState(false);

  useEffect(() => {
    let cancelled = false;

    if (plans) {
      Promise.all(plans?.map((p) => getPlan(p.id))).then((results) => {
        const hasMatch = results.some((planBenefit) => medicarePartDStrategies.includes(planBenefit.plan_benefit.coverage_strategy_type));

        if (!cancelled) {
          setHasMedicarePlans(hasMatch);
        }
      });
    }

    return () => {
      cancelled = true;
    };
  }, [plans]);

  return hasMedicarePlans;
};

export const useIsMedicarePartD = (planId?: number) => {
  const [isMedicarePartD, setIsMedicarePartD] = useState(undefined);

  useEffect(() => {
    if (!planId) {
      setIsMedicarePartD(undefined);
      return;
    }

    let cancelled = false;

    getPlan(planId).then((planBenefit) => {
      if (cancelled) return;

      const coverageStrategyType = planBenefit.plan_benefit.coverage_strategy_type;

      const hasMatch = medicarePartDStrategies.includes(coverageStrategyType);

      setIsMedicarePartD(hasMatch);
    });

    return () => {
      cancelled = true;
    };
  }, [planId]);

  return isMedicarePartD;
};
